export default __webpack_public_path__ + "static/media/500.d508258f.svg";